import { Box, Card, CardContent, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceDetailCleanUp, getInsurances } from '../../../../redux/insurance/action';
import { formatDate } from '../../../common/functionUtils';
import Label from '../../../common/type/Label';
const InsuranceCard = () => {
    const dispacth = useDispatch();
    const tenantInfo = localStorage.getItem('tenantHandle');
    const insuranceDetails = useSelector(state => state?.insurances?.insurances);
    useEffect(()=> {
        dispacth(getInsurances(tenantInfo));
        return ()=> {
            dispacth(getInsuranceDetailCleanUp());
        };
    },
    []);
    return (
        <Box className='securityBox'>
                  <Card className='securityBoxHeader'>
                  <h3 className='privacypolicy-section'><Label id="thirdPartyInsurance"/></h3>
                  </Card>
                  {insuranceDetails && insuranceDetails?.memberDetail && insuranceDetails?.coordinationOfBenefitsItemList && insuranceDetails?.coordinationOfBenefitsItemList.length !== 0 ? (<>
                  {insuranceDetails?.coordinationOfBenefitsItemList.map((element, index)=>              
                   <Card className='securityPassword insuranceCard' key={index}>
                      <CardContent className='insuranceName'>
                         <Typography variant='h6'>{insuranceDetails?.memberDetail?.firstName + ' ' + insuranceDetails?.memberDetail?.lastName} </Typography> 
                      </CardContent>
                      <CardContent className='insurancePlanDetails'>
                          <Typography variant='h6'><Label id="insurancePlan"/></Typography>
                          <Typography variant='body1'>{element?.insuranceTypeDescription}</Typography>
                      </CardContent>
                      <CardContent className='insurancePlanDetails'>
                          <Typography variant='h6'><Label id="effectiveDate"/></Typography>
                          <Typography variant='body1'>{formatDate(element?.effectiveDate)}</Typography>
                      </CardContent>
                      <CardContent className='insurancePlanDetails'>
                          <Typography variant='h6'><Label id="termDate"/></Typography>
                          <Typography variant='body1'>{formatDate(element?.termDate)}</Typography>
                      </CardContent>
                  </Card> )}
                  </>
                //       <Card className='securityPassword insuranceCard'>
                //       <CardContent className='insuranceName'>
                //          <Typography variant='h6'>{insuranceDetails?.memberDetail?.firstName + ' '+ insuranceDetails?.memberDetail?.lastName}</Typography> 
                //       </CardContent>
                //     {insuranceDetails.coordinationOfBenefitsItemList?.map((element , index)=><CardContent className='insurancePlanDetails' key={index}>
                //           <Typography variant='h6'>Insurance Plan</Typography>
                //           <Typography variant='body1'>{element?.insuranceTypeDescription}</Typography>
                //       </CardContent>)}
                //   </Card>
                  ): (
                      <Card className='securityPassword insuranceCard'><Label id="no3rdPartyInsurance"/></Card>
                  )}
    
        </Box>
    );
};

export default InsuranceCard;
